/* eslint-disable no-console */

/**
 * Development logging utility - suppresses logs on production domain.
 * @param message - Log message.
 * @param data - Optional data to log.
 */
export const devLog = (message: string, data?: unknown): void => {
  if (typeof window === 'undefined') return;

  if (window.location?.hostname === 'www.osmosis.org') return;

  if (data !== undefined) {
    console.log(message, data);
  } else {
    console.log(message);
  }
};
